import React from 'react';
import { getMessage } from '@tcc/i18n';
import styles from '../RegionNoteForm.css';
import ConfirmationModal from '../../../../containers/Modal/ConfirmationModal';

export type RemovePhotoConfirmationModalProps = {
  confirmTitleKey: string;
  onWarningModal: () => void;
  onCancelGoBack: () => void;
  onClickCancel: () => void;
};

export const RemovePhotoConfirmationModal = ({
  confirmTitleKey,
  onWarningModal,
  onCancelGoBack,
  onClickCancel,
}: RemovePhotoConfirmationModalProps) => (
  <div
    className={styles.confirmationModalContainer}
    data-test-id="region-note-form-remove-photo-confirmation-modal"
  >
    <ConfirmationModal
      title={getMessage('regionNote.form.removePhoto.warning.title')}
      subTitle={getMessage('regionNote.form.removePhoto.warning.description')}
      confirmButtonText={getMessage(confirmTitleKey)}
      handleClickConfirm={onWarningModal}
      handleClickGoBack={onCancelGoBack}
      handleClickCancel={onClickCancel}
    />
  </div>
);
